export const s3 = (path: string): string =>
  `https://s3.eu-central-1.amazonaws.com/identiteitsplein/${path}`
